export default __webpack_public_path__ + "static/media/zenodo-authorize.92b86be5.png";